/**
 * 目标选择弹窗
 * 
 * 选择卡牌作用的目标角色
 */

import React from 'react';
import type { Character, GameCard } from '../../../types';

interface TargetSelectModalProps {
  selectedCard: GameCard | null;
  charA: Character;
  charB: Character;
  onSelectTarget: (card: GameCard, target: 'A' | 'B') => void;
  onCancel: () => void;
}

export const TargetSelectModal: React.FC<TargetSelectModalProps> = ({
  selectedCard,
  charA,
  charB,
  onSelectTarget,
  onCancel,
}) => {
  if (!selectedCard) return null;

  const handleSelectTarget = (target: 'A' | 'B') => {
    onSelectTarget(selectedCard, target);
  };

  return (
    <div className="absolute inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-xl">
        {/* Header */}
        <div className="bg-[#FFF8F0] p-4 border-b border-[#E5E0D8]">
          <h3 className="text-xl font-bold text-[#2D2D2D] text-center">{selectedCard.name}</h3>
          <p className="text-sm text-[#6B7280] text-center mt-1">{selectedCard.description}</p>
          <p className="text-xs text-[#FFB347] italic text-center mt-2">{selectedCard.hint}</p>
        </div>
        
        {/* Target buttons */}
        <div className="p-4">
          <p className="text-center text-sm font-bold text-[#2D2D2D] mb-4">对谁使用？</p>
          <div className="grid grid-cols-2 gap-4">
            <button
              onClick={() => handleSelectTarget('A')}
              className="p-4 bg-[#FFF8F0] rounded-2xl flex flex-col items-center gap-2 border border-[#E5E0D8] hover:border-[#FF6B6B] hover:shadow-md transition-all"
            >
              <img src={charA.avatar} className="w-14 h-14 rounded-full shadow-sm" alt={charA.name} />
              <span className="text-sm font-bold text-[#2D2D2D]">{charA.name}</span>
            </button>
            <button
              onClick={() => handleSelectTarget('B')}
              className="p-4 bg-[#FFF8F0] rounded-2xl flex flex-col items-center gap-2 border border-[#E5E0D8] hover:border-[#FF6B6B] hover:shadow-md transition-all"
            >
              <img src={charB.avatar} className="w-14 h-14 rounded-full shadow-sm" alt={charB.name} />
              <span className="text-sm font-bold text-[#2D2D2D]">{charB.name}</span>
            </button>
          </div>
        </div>
        
        {/* Cancel */}
        <button
          onClick={onCancel}
          className="w-full py-3 text-[#9CA3AF] text-sm hover:text-[#6B7280] transition-colors"
        >
          取消
        </button>
      </div>
    </div>
  );
};
